<script setup lang="ts">
import { YandexMapMarker } from 'vue-yandex-maps'

import type { LngLat } from '@yandex/ymaps3-types'
import {
  BalloonType,
  DeliveryDataAddress,
} from '@/store/delivery/delivery.types'

import { StateGeoAddress } from '@/types/mapServices'

import BalloonMarker from '@/components/Services/Balloons/BalloonMarker.vue'

import type { PolygonProperties } from '@/api/modules/delivery/types'

type Props = {
  clickedMarkerCoordinates: LngLat
  deliveryAddressDetails: PolygonProperties | null
  selectedAddress: DeliveryDataAddress | null
  balloonType: BalloonType
}

const props = defineProps<Props>()

const generateSettings = computed(() => {
  return {
    coordinates: props.clickedMarkerCoordinates,
    properties: { markerOfClick: true },
    zIndex: 1,
  }
})

const isLoading = computed(
  () => props.selectedAddress?.state === StateGeoAddress.LOADING,
)
</script>

<template>
  <yandex-map-marker
    :settings="generateSettings"
    position="top-center left-center"
  >
    <balloon-marker
      :is-loading="isLoading"
      :balloon-type="balloonType"
      :details="deliveryAddressDetails"
      :selected-address="selectedAddress"
    />
  </yandex-map-marker>
</template>
